
import {Component, Prop, Vue} from 'vue-property-decorator';
import { RideitNotice } from '@/models/Rideit/RideitNotice';

@Component({
  components: {
  }
})
export default class RideitCommunicationsForm extends Vue {
  formRef = 'communicationsForm' as const;

  @Prop({ default: () => []}) private notices: RideitNotice[];

  search: string = '';
  disableCreateNoticeButton: boolean = false;

  createNotice() {
    this.$emit('create-notice');
  }

  updateSearch(value: string) {
    this.search = value;
    this.$emit('update:search', value);
  }

}
